/**
 * Map styles
 */
class MapStyles {
    static get defaultStyle() {
        return [
            {
                "featureType": "landscape",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 60 },
                    { "gamma": 0.9 }
                ]
            },{
                "featureType": "water",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 20 },
                    { "gamma": 1 }
                ]
            },{
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "on" }
                ]
            },{
                "featureType": "administrative",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 20 },
                    { "gamma": 1 }
                ]
            },{
                "featureType": "administrative",
                "elementType": "labels",
                "stylers": [
                    { "visibility": "on" }
                ]
            },{
                "featureType": "poi",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 35 },
                    { "gamma": 1 }
                ]
            },{
                "featureType": "road",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 10 },
                    { "gamma": 0.5 }
                ]
            },{
                "featureType": "transit",
                "stylers": [
                    { "visibility": "on" },
                    { "hue": "#ff0000" },
                    { "saturation": -100 },
                    { "lightness": 10 },
                    { "gamma": 0 }
                ]
            }
        ];
    }
    /**
     *
     * @returns {*[]}
     */
    static get () {
        return MapStyles.defaultStyle;
    }
}

export default MapStyles;
